export const RelationElement =  ()=>{
    return (
        <div className="container">
            カードに紐づいているカードの条件です。下記例ではequipという名の紐づけで紐づけ種別はモンスター効果(リレーションタイプは1となっていますが、右のセレクトボックスで選ぶことで別の数値を出すことも可能です)。さらに、紐づけを受けるようにしています  
            <p><img src={`${process.env.PUBLIC_URL}/dialogbox_relation.png`}></img></p>
        </div>
    )
}
